const common = {
  "nav.home": "Home",
  "nav.advantages": "Advantages",
  "nav.industries": "Industries",
  "nav.testimonials": "Testimonials",
  "nav.pricing": "Pricing",
  "nav.faq": "FAQ",
  "nav.contact": "Contact",
  "nav.dashboard": "Dashboard",
  "nav.signIn": "Sign In",
  "nav.logout": "Logout",
  "nav.toggleMenu": "Toggle menu",
  "nav.profile": "Profile",
  "nav.language": "Language",
  "nav.settings": "Settings",
  "footer.tagline": "Stay ahead of the curve",
  "footer.description": "Get updates on new features, industry insights, and tips on showcasing your advantages effectively.",
  "footer.newsletter.placeholder": "Type your message...",
  "footer.newsletter.subscribe": "WhatsApp",
  "footer.navigation": "Navigation",
  "footer.contact": "Contact",
  "footer.location": "Location",
  "footer.privacy": "Privacy",
  "footer.terms": "Terms",
  "footer.copyright": "© 2026 Wyzon. All rights reserved.",
  "footer.address": "123 Innovation Drive, San Francisco, CA 94102",
  "footer.phone": "+20 109 9289 280",
  "footer.email": "sales@debugin.com",
  "loading": "Loading...",
  "error.generic": "Something went wrong",
  "error.network": "Network error. Please check your internet connection and try again.",
  "error.failedToFetch": "Failed to connect to server. Please ensure the backend is running and try again.",
  "error.sessionNotFound": "Session not found or expired. Please log in again.",
  "error.failedToSend": "Failed to send message. Please ensure the recipient number is valid and connected.",
  "error.rateLimit": "Rate limit exceeded. Please try again in a few moments.",
  "error.unauthorized": "Unauthorized access. Please log in again.",
  "error.token": "Authentication token is invalid or expired. Please regenerate a new token.",
  "error.timeout": "Request timed out. Please try again.",
  "error.qr": "Failed to generate QR Code. Please check phone connection and try again.",
  "error.phone": "The phone number is invalid or not registered on WhatsApp.",
  "error.invalidFormat": "Invalid file format. Please ensure you upload a supported file type.",
  "error.unexpected": "An unexpected error occurred. Please try again later.",
  "button.tryAgain": "Try Again",
  "button.back": "Back",
  "button.submit": "Submit",
  "button.cancel": "Cancel",
  "button.close": "Close",
  "language.en": "English",
  "language.ar": "العربية",
  "direction": "ltr",
  "plan.basic": "Basic",
  "plan.pro": "Pro",
  "plan.enterprise": "Enterprise",
  "brandName": "Wyzon",

  // Countries
  "country.20": "Egypt",
  "country.966": "Saudi Arabia",
  "country.971": "UAE",
  "country.965": "Kuwait",
  "country.974": "Qatar",
  "country.973": "Bahrain",
  "country.968": "Oman",
  "country.962": "Jordan",
  "country.961": "Lebanon",
  "country.963": "Syria",
  "country.964": "Iraq",
  "country.967": "Yemen",
  "country.970": "Palestine",
  "country.218": "Libya",
  "country.216": "Tunisia",
  "country.213": "Algeria",
  "country.212": "Morocco",
  "country.249": "Sudan",
  "country.252": "Somalia",
  "country.1": "USA",
  "country.44": "UK",
  "country.33": "France",
  "country.49": "Germany",
};

export default common;